import { SearchField } from '@purpur/library';
import styled from 'styled-components';

import { CheckboxText, StyledLabel } from '@telialt/common-checkbox/src/Checkbox.styles';
import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const CheckboxFilterTreeContainer = styled.div`
    [role='list'] {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }
    [role='list'] [role='list'] {
        padding-left: ${getPurpurSpacing('400')};
    }
    ${StyledLabel}, ${CheckboxText} {
        width: 100%;
    }
`;

export const SpaceBetweenWrapper = styled.span`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    column-gap: ${getPurpurSpacing('200')};
`;

export const SearchBox = styled(SearchField)`
    margin-bottom: ${getPurpurSpacing('200')};
`;
